import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'aiecosystem',
});

export const personalServicesRouteRef = createSubRouteRef({
  id: 'aiecosystem:services',
  parent: rootRouteRef,
  path: '/services',
});

export const modelgardenRouteRef = createSubRouteRef({
  id: 'aiecosystem:modelgarden',
  parent: rootRouteRef,
  path: '/modelgarden',
});

export const masspRouteRef = createSubRouteRef({
  id: 'aiecosystem:massp4ai',
  parent: rootRouteRef,
  path: '/massp4ai',
});

export const agentgardenRouteRef = createSubRouteRef({
  id: 'aiecosystem:agentgarden',
  parent: rootRouteRef,
  path: '/agentgarden',
});

export const mcpgardenRouteRef = createSubRouteRef({
  id: 'aiecosystem:mcpgarden',
  parent: rootRouteRef,
  path: '/mcpgarden',
});

export const templatesRouteRef = createSubRouteRef({
  id: 'aiecosystem:templates',
  parent: rootRouteRef,
  path: '/templates',
});

export const aiplaygroundRouteRef = createSubRouteRef({
  id: 'aiecosystem:aiplayground',
  parent: rootRouteRef,
  path: '/aiplayground',
});

export const agentictoolingRouteRef = createSubRouteRef({
  id: 'aiecosystem:agentictooling',
  parent: rootRouteRef,
  path: '/agentictooling',
});
